export default {"src":"/_next/static/media/close-circle-fill.dee70562.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};